module.exports = __webpack_public_path__ + "static/media/transporter-3.2a02e829.svg";